import { WorkflowSchoolkeepStage } from 'api-clients/monolith';
import React, { VFC } from 'react';
import { useSelector } from 'react-redux';

import { makeUniversalRecruiterDashboardEnabled } from 'containers/Auth_old/selectors';
import { ReviewStage } from 'containers/WorkflowEditor/components/ReviewStage';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';

import { IdleMoveRule } from '../../../IdleMoveRule';
import { StageSettingMessageCard } from '../../../StageSettingMessageCard';
import { IntegrationCard } from './IntegrationCard';

export interface SchoolkeepStageProps {
  stage: WorkflowSchoolkeepStage;
}

export const SchoolkeepStage: VFC<SchoolkeepStageProps> = ({ stage }) => {
  const universalRecruiterDashboardEnabled = useSelector(
    makeUniversalRecruiterDashboardEnabled(),
  );

  return (
    <div data-testid="schoolkeepStage">
      {universalRecruiterDashboardEnabled && (
        <StageSection>
          <ReviewStage stage={stage} />
        </StageSection>
      )}
      <StageSection>
        <IntegrationCard stage={stage} />
      </StageSection>
      <StageSection>
        <IdleMoveRule stage={stage} />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="schoolkeep"
          stageExternalId={stage.external_id}
        />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="trigger"
          stageExternalId={stage.external_id}
        />
      </StageSection>
    </div>
  );
};
